import { useHistory } from "react-router-dom";
import { ConciliacaoUploadContext } from "../contexts/ConciliacaoUploadContext";
import { useCallback, useContext } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { notify } from "../../../../utils/notify";
import getBase64 from "../../../../utils/getBase64";
import {
  convertPdf,
  deleteOfxConciliation,
  getHistoric,
  openFinanceConciliation,
  pedingConciliation,
  reopenFileOfxConciliation,
  uploadOfx,
} from "../../../../repositories/qerpapi/erp/financeiro/ConciliacaoBancariaRepository";
import Swal from "sweetalert2";
import { downloadObjectS3 } from "../../../../repositories/qerpapi/erp/aws/v1/S3Repository";
import { b64toBlob } from "../../../../utils/file64toBlob";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import {
  disconnectOpenFinance,
  getOpenFinanceAgencies,
  getOpenFinanceRetroactive,
} from "../../../../repositories/qerpapi/v3/bankReconcilliation/BankReconcilliationRepository";

const useConciliacaoUploadController = () => {
  const { push } = useHistory();
  const { queryParams } = useContext(QueryParamsContext);

  const {
    setLoading,
    bankAgencies,
    setHistoricDataTable,
    bankAccount,
    status,
    initialDate,
    finalDate,
    dateFrom,
    setPagePropDefault,
    setOpenFinanceDataTable,
  } = useContext(ConciliacaoUploadContext);

  const { setConciliationType } = useContext(ConciliacaoBancariaContext);

  const handleUpload = async (file = null, customFile) => {
    if (!file && !customFile) return notify("Nenhum arquivo selecionado.");

    try {
      setLoading(true);

      var base64;
      if (!file && customFile) {
        base64 = customFile.base64;
      } else {
        base64 = await getBase64(file.file);
        base64 = base64.split("data:application/octet-stream;base64,")[1];
      }

      var fileName = file ? file.name : customFile.name;

      const callback = await uploadOfx({
        empresa_cnpj: queryParams.empresa_cnpj,
        empresa_id: queryParams.empresa_id,
        usuario_id: queryParams.usuario_id,
        body: {
          arquivo: {
            base64,
            nome: fileName,
          },
          empresa_id: queryParams.empresa_id,
        },
      });

      if (callback.success) {
        if (callback?.data?.duplicateTransactions) {
          var auxiliaryMessage =
            "<div class='duplicateTransactions'> Identificamos transações duplicadas no arquivo OFX importado. Para manter a clareza e evitar redundâncias na conciliação bancária, exibiremos uma de cada transação duplicada: <br/><br/>";
          Object.keys(callback.data.duplicateTransactions).forEach((key) => {
            auxiliaryMessage += `${callback.data.duplicateTransactions[key]} <br/>`;
          });
          auxiliaryMessage += "</div>";
        }

        Swal.fire({
          icon: "success",
          title: callback.message,
          html: auxiliaryMessage ?? null,
          confirmButtonText: "Ok",
          cancelButtonText: "Imprimir",
          showConfirmButton: true,
          showCancelButton: callback?.data?.duplicateTransactions,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            push(
              `conciliacao?empresa_cnpj=${queryParams.empresa_cnpj}&empresa_id=${queryParams.empresa_id}&usuario_id=${queryParams.usuario_id}`,
              {
                ...callback.data.transactionsInformation,
                bankAccounts: bankAgencies,
              }
            );
          } else {
            setLoading(true);
            const callbackPdf = await convertPdf({
              title: "Transações Duplicadas",
              html: btoa(unescape(encodeURIComponent(auxiliaryMessage))),
              login: queryParams?.usuario_nome,
            });

            if (callbackPdf.status !== 200) {
              setLoading(false);
              return notify("Ocorreu um erro ao tentar imprimir");
            }

            const blob = b64toBlob(
              callbackPdf?.data?.fileBase64,
              "application/pdf"
            );
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl);
            push(
              `conciliacao?empresa_cnpj=${queryParams.empresa_cnpj}&empresa_id=${queryParams.empresa_id}&usuario_id=${queryParams.usuario_id}`,
              {
                ...callback.data.transactionsInformation,
                bankAccounts: bankAgencies,
              }
            );
          }
        });
      } else {
        if (callback?.data?.id) {
          Swal.fire({
            icon: "question",
            text: "Arquivo já importado deseja continuar a conciliação a partir dele?",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Sim",
            showConfirmButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            try {
              setLoading(true);
              if (result.isConfirmed) {
                const callbackPending = await pedingConciliation({
                  empresa_cnpj: queryParams.empresa_cnpj,
                  file_ofx_id: callback?.data?.id,
                  empresa_id: queryParams.empresa_id,
                });

                if (!callbackPending.success)
                  return notify("Erro ao buscar títulos pendentes!");

                push(
                  `conciliacao?empresa_cnpj=${queryParams.empresa_cnpj}&empresa_id=${queryParams.empresa_id}&usuario_id=${queryParams.usuario_id}`,
                  {
                    ...callbackPending.data,
                    bankAccounts: bankAgencies,
                    linkedBank: callback?.data?.agencia_id,
                  }
                );
              }
            } catch (e) {
              console.error(e);
            } finally {
              setLoading(false);
            }
          });
        } else return notify(callback.message);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleOfxDownload = async (s3Key, fileName) => {
    if (!s3Key) return notify("Erro ao fazer o download do arquivo!");

    const sendBody = {
      bucket: "qerp-private",
      key: s3Key,
    };

    try {
      setLoading(true);
      const response = await downloadObjectS3({
        empresa_cnpj: queryParams.empresa_cnpj,
        empresa_id: queryParams.empresa_id,
        body: sendBody,
      });

      if (!response?.data?.archive_base64)
        return notify("Falha ao realizar o download.");

      let fileBase64 = response.data.archive_base64;

      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:application/octet-stream;base64," +
          encodeURIComponent(
            fileBase64.substring(
              fileBase64.split("").findIndex((e) => e === ",") + 1
            )
          )
      );

      element.setAttribute("download", fileName);

      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);

      notify("Download realizado com sucesso.", true, "success");
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleOfxDelete = async (id) => {
    Swal.fire({
      title: "Confirmação",
      text: "Você tem certeza que deseja excluir este arquivo OFX?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const response = await deleteOfxConciliation({
            empresa_cnpj: queryParams.empresa_cnpj,
            id,
          });

          if (!response.success) {
            return notify(response.message);
          } else {
            notify("Arquivo OFX excluído com sucesso!", true, "success");
            handleGetDataTable();
          }
        } catch (e) {
          console.error(e);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleGetOpenFinanceDataTable = useCallback(async () => {
    let response = await getOpenFinanceAgencies();

    if (!response?.success)
      return notify("Erro ao buscar a integração com o Open Finance!");

    if (response?.data && response?.data?.length > 0) {
      setOpenFinanceDataTable(response?.data);
    }
  }, [setOpenFinanceDataTable]);

  const handleGetDataTable = async () => {
    if (!status) return notify("Selecione o status.", true, "warning");

    if ((!initialDate && finalDate) || (initialDate && !finalDate))
      return notify(
        "Por favor preencha ambas as datas ou nenhuma.",
        true,
        "warning"
      );

    if (
      initialDate &&
      finalDate &&
      Date.parse(initialDate) > Date.parse(finalDate)
    ) {
      return notify(
        "A data inicial não pode ser maior que a data final.",
        true,
        "warning"
      );
    }

    if (!dateFrom || !dateFrom?.value)
      return notify("Selecione a data de pesquisa.", true, "warning");

    try {
      setLoading(true);

      const response = await getHistoric({
        empresa_cnpj: queryParams.empresa_cnpj,
        empresa_id: queryParams.empresa_id,
        agencia_id: bankAccount?.id || null,
        type: dateFrom.value,
        status: status.value,
        data_start: initialDate,
        data_end: finalDate,
      });

      if (!response?.success) return notify("Erro ao buscar o histórico!");

      setPagePropDefault(0);
      setHistoricDataTable(response?.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenConciliation = async (
    ofxId,
    bankId,
    historicVisualization = false
  ) => {
    try {
      setLoading(true);
      const callbackPending = await pedingConciliation({
        empresa_cnpj: queryParams.empresa_cnpj,
        file_ofx_id: ofxId,
        empresa_id: queryParams.empresa_id,
      });

      if (!callbackPending.success)
        return notify("Erro ao buscar títulos pendentes!");

      push(
        `conciliacao?empresa_cnpj=${queryParams.empresa_cnpj}&empresa_id=${queryParams.empresa_id}&usuario_id=${queryParams.usuario_id}`,
        {
          ...callbackPending.data,
          bankAccounts: bankAgencies,
          historicVisualization: historicVisualization,
          linkedBank: bankId,
        }
      );
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenFinanceConciliation = async (
    agencyId,
    startDate,
    endDate,
    bankId,
    historicVisualization = false
  ) => {
    try {
      setLoading(true);
      setConciliationType("openFinance");

      const callbackPending = await openFinanceConciliation({
        empresa_cnpj: queryParams.empresa_cnpj,
        agencia_id: agencyId,
        start_date: startDate,
        end_date: endDate,
        empresa_id: queryParams.empresa_id,
      });

      if (!callbackPending.success)
        return notify("Erro ao buscar títulos pendentes!");

      push(
        `conciliacao?empresa_cnpj=${queryParams.empresa_cnpj}&empresa_id=${queryParams.empresa_id}&usuario_id=${queryParams.usuario_id}`,
        {
          ...callbackPending.data,
          bankAccounts: bankAgencies,
          historicVisualization: historicVisualization,
          linkedBank: bankId,
          conciliationType: "openFinance",
        }
      );
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleReopenFileOfxConciliation = async (ofxFileId) => {
    try {
      setLoading(true);
      const callback = await reopenFileOfxConciliation({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: {
          userId: queryParams.usuario_id,
          ofxFileId: ofxFileId,
        },
      });

      if (!callback.success) {
        return notify(callback.message);
      } else {
        const response = await getHistoric({
          empresa_cnpj: queryParams.empresa_cnpj,
          empresa_id: queryParams.empresa_id,
          agencia_id: bankAccount?.id || null,
          type: dateFrom.value,
          status: status.value,
          data_start: initialDate,
          data_end: finalDate,
        });

        if (!response?.success) return notify("Erro ao buscar o histórico!");

        setHistoricDataTable(response?.data || []);
        return notify(
          "Conciliação do arquivo reaberta com sucesso!",
          true,
          "success"
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenFinanceDisconnect = async (agencyId) => {
    try {
      setLoading(true);
      const callback = await disconnectOpenFinance(agencyId);

      if (!callback.success) {
        return notify(callback.message);
      } else {
        return notify(
          "Integração com o Open Finance desconectada!",
          true,
          "success"
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleGetOpenFinanceRetroactive = async (agencyId, startDate, endDate) => {
    try {
      setLoading(true);
      const callback = await getOpenFinanceRetroactive(agencyId, startDate, endDate);

      if (!callback.success) {
        return notify(callback.message);
      } else {
        return notify(
          "Transações retroativas solicitadas com sucesso! Aguarde o processamento e retorne para visualizar.",
          true,
          "success"
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleOfxDownload,
    handleUpload,
    handleGetDataTable,
    handleOpenConciliation,
    handleReopenFileOfxConciliation,
    handleOpenFinanceConciliation,
    handleGetOpenFinanceDataTable,
    handleOpenFinanceDisconnect,
    handleGetOpenFinanceRetroactive,
    handleOfxDelete,
  };
};

export default useConciliacaoUploadController;
